module.exports = __webpack_public_path__ + "img/线条猫耳朵.f66ba0c0.gif";